export const FEATURE_FLAG = false
export const DEBIT_CARD_PRICE = { card: "5.05", shipping: "10.30" }